import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import cr from "../assest/cr.png";
import Logo from "../assest/l.png";
import { FaBackward } from "react-icons/fa";

const typewriterTexts = [
    "Find Your Dream Co-Founder",
    "Build Ideas Together",
    "Start Something Big!",
];

export default function RegistrationforCofounder() {
    const [step, setStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isStartup, setIsStartup] = useState(false);

    const navigate = useNavigate();

    const validateField = (name, value) => {
        switch (name) {
            case "fullName":
                if (!value || !/^[A-Za-z\s]+$/.test(value)) {
                    return "Full Name should contain only letters and spaces.";
                }
                break;
            case "email":
                if (!value || !/^[^\s@]+@gmail\.com$/.test(value)) {
                    return "Email must be a valid Gmail address.";
                }
                break;
            case "phoneNumber":
                if (!value || !/^\d{10}$/.test(value)) {
                    return "Phone Number must be exactly 10 digits.";
                }
                break;
            case "district":
                if (!value) {
                    return "Please select a district.";
                }
                break;
            case "employmentStatus":
                if (!value) {
                    return "Please select your employment status.";
                }
                break;
            case "industries":
                if (!value) {
                    return "Please enter industries you're interested in.";
                }
                break;
            case "resume":
                if (!value) {
                    return "Please upload your resume.";
                }
                break;
            default:
                break;
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const currentFields = sections[step].fields;
        for (let field of currentFields) {
            const error = validateField(field.name, formData[field.name]);
            if (error) {
                setErrorMessage(`⚠️ ${error}`);
                return;
            }
        }

        setLoading(true);

        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((val) => formDataToSend.append(key, val));
            } else {
                formDataToSend.append(key, value);
            }
        });

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/cofounderregister`,
                formDataToSend,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            console.log(response.data);
            setSubmitted(true);
        } catch (error) {
            console.error("Error submitting form:", error);
            setErrorMessage("Submission failed! Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, type, value, files } = e.target;

        if (type === "tel") {
            const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
            setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
        } else if (type === "file") {
            const file = files[0];
            if (file && file.type !== "application/pdf") {
                setErrorMessage("⚠️ Only PDF files are allowed for CV upload.");
                return;
            } else {
                setErrorMessage("");
                setFormData((prev) => ({ ...prev, [name]: file }));
            }
        } else if (type === "text" && name === "fullName") {
            const cleanedValue = value.replace(/[^A-Za-z\s]/g, "");
            setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === "file" ? files[0] : value,
            }));
        }
    };

    const handleNext = () => {
        const currentFields = sections[step].fields;
        for (let field of currentFields) {
            const error = validateField(field.name, formData[field.name]);
            if (error) {
                setErrorMessage(`⚠️ ${error}`);
                return;
            }
        }
        setErrorMessage("");
        setStep((prevStep) => prevStep + 1);
    };

    const sections = [
        {
            title: "Personal Information",
            fields: [
                {
                    label: "Full Name",
                    type: "text",
                    name: "fullName",
                    required: true,
                },
                {
                    label: "Email Address",
                    type: "email",
                    name: "email",
                    required: true,
                },
                {
                    label: "Phone Number",
                    type: "tel",
                    name: "phoneNumber",
                    required: true,
                },
                {
                    label: "LinkedIn Profile",
                    type: "url",
                    name: "linkedin",
                    required: true,
                    placeholder: "https://www.linkedin.com/in/yourname",
                },
                {
                    label: "District",
                    type: "select",
                    name: "district",
                    required: true,
                    options: [
                        "Ariyalur",
                        "Chengalpattu",
                        "Chennai",
                        "Coimbatore",
                        "Cuddalore",
                        "Dharmapuri",
                        "Dindigul",
                        "Erode",
                        "Kallakurichi",
                        "Kanchipuram",
                        "Kanyakumari",
                        "Karur",
                        "Krishnagiri",
                        "Madurai",
                        "Mayiladuthurai",
                        "Nagapattinam",
                        "Namakkal",
                        "Nilgiris",
                        "Perambalur",
                        "Pudukkottai",
                        "Ramanathapuram",
                        "Ranipet",
                        "Salem",
                        "Sivaganga",
                        "Tenkasi",
                        "Thanjavur",
                        "Theni",
                        "Thoothukudi",
                        "Tiruchirappalli",
                        "Tirunelveli",
                        "Tirupathur",
                        "Tiruppur",
                        "Tiruvallur",
                        "Tiruvannamalai",
                        "Tiruvarur",
                        "Vellore",
                        "Viluppuram",
                        "Virudhunagar",
                    ],
                },
            ],
        },
        {
            title: "Professional Interests",
            fields: [
                {
                    label: "Employment Status",
                    type: "select",
                    name: "employmentStatus",
                    required: true,
                    options: ["Employed", "Unemployed", "Student"],
                },
                {
                    label: "Industries Interested In",
                    type: "text",
                    name: "industries",
                    required: true,
                },
                {
                    label: "Resume or Portfolio",
                    type: "file",
                    name: "resume",
                    accept: ".pdf",
                    required: true,
                },
            ],
        },
    ];

    // Handle toggle switch change
    const handleToggle = () => {
        setIsStartup((prev) => !prev);
        if (!isStartup) {
            navigate("/startup-reg");
        }
    };

    return (
        <div className="w-full h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
            <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
                {/* Left Side - Form */}
                <div className="md:w-1/2 w-full bg-white px-8 py-6 h-full overflow-y-auto">
                    <div className="flex justify-start mb-4">
                        <Link to="/" className="flex items-center space-x-2">
                            <img src={Logo} alt="Back to Home" className="w-28" />
                        </Link>
                    </div>

                    {/* Toggle switch to register as Co-founder */}
                    <div className="flex items-center justify-center mb-4">
                        <div className="inline-flex rounded-full bg-gray-200 p-1">
                            {/* Co-founder button */}
                            <button
                                type="button"
                                onClick={() => {
                                    if (isStartup) {
                                        handleToggle();
                                    }
                                }}
                                className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${!isStartup
                                        ? "bg-gradient-to-r from-[#E7603C] via-[#B9309A] to-[#B97639] text-white"
                                        : "bg-transparent text-gray-700"
                                    }`}
                            >
                                Co founder
                            </button>

                            {/* Startup button */}
                            <button
                                type="button"
                                onClick={() => {
                                    if (!isStartup) {
                                        handleToggle();
                                    }
                                }}
                                className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${isStartup
                                        ? "bg-gradient-to-r from-[#E7603C] via-[#B9309A] to-[#B97639] text-white"
                                        : "bg-transparent text-gray-700"
                                    }`}
                            >
                                Startup
                            </button>
                        </div>
                    </div>

                    <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
                        CoFounder Registration
                    </h2>

                    {submitted ? (
                        <div className="text-center mt-6">
                            <h3 className="text-2xl font-semibold text-green-600 mb-4">
                                🎉 Registration Successful!
                            </h3>
                            <button
                                onClick={() => {
                                    setSubmitted(false);
                                    setStep(0);
                                    setFormData({});
                                }}
                                className="px-6 py-2 bg-indigo-600 text-white rounded-full hover:bg-indigo-700"
                            >
                                Register Another
                            </button>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-5 text-sm w-full lg:w-1/2 mx-auto">
                            {errorMessage && (
                                <motion.div
                                    initial={{ y: -10, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                    className="bg-red-100 text-red-700 p-3 rounded text-sm"
                                >
                                    {errorMessage}
                                </motion.div>
                            )}

                            <div className="flex justify-center space-x-2 mt-4">
                                {sections.map((_, index) => (
                                    <span
                                        key={index}
                                        className={`h-2 w-8 rounded-full transition-all duration-300 ${index <= step ? "bg-[#4b154c]" : "bg-gray-300"
                                            }`}
                                    />
                                ))}
                            </div>

                            <h3 className="text-lg font-medium text-[#4b154c] text-center">
                                {sections[step]?.title}
                            </h3>

                            {sections[step]?.fields.map((field, idx) => (
                                <div key={idx} className="flex flex-col">
                                    <label
                                        htmlFor={field.name}
                                        className="text-gray-700 font-medium mb-1"
                                    >
                                        {field.label}
                                    </label>

                                    {field.type === "file" ? (
                                        <div className="flex flex-col items-start">
                                            <label className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-full cursor-pointer text-sm border-none">
                                                Choose File
                                                <input
                                                    type="file"
                                                    name={field.name}
                                                    onChange={handleChange}
                                                    className="hidden"
                                                    accept={field.accept}
                                                />
                                            </label>
                                            {formData[field.name]?.name && (
                                                <span className="text-gray-600 text-xs mt-1">
                                                    {formData[field.name].name}
                                                </span>
                                            )}
                                        </div>
                                    ) : field.type === "select" ? (
                                        <select
                                            name={field.name}
                                            value={formData[field.name] || ""}
                                            onChange={handleChange}
                                            className="w-full bg-gray-200 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                                        >
                                            <option value="">-- Select --</option>
                                            {field.options.map((option, i) => (
                                                <option key={i} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type={field.type}
                                            name={field.name}
                                            value={formData[field.name] || ""}
                                            onChange={handleChange}
                                            className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                                            placeholder={field.placeholder || field.label}
                                        />
                                    )}
                                </div>
                            ))}

                            <div className="flex items-center justify-between mt-6">
                                {step > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => setStep((prev) => prev - 1)}
                                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 text-sm"
                                    >
                                        Back
                                    </button>
                                )}
                                {step < sections.length - 1 && (
                                    <button
                                        type="button"
                                        onClick={handleNext}
                                        className="ml-auto px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm"
                                    >
                                        Next
                                    </button>
                                )}
                                {step === sections.length - 1 && (
                                    <button
                                        type="submit"
                                        className="ml-auto px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm disabled:opacity-50"
                                        disabled={loading}
                                    >
                                        {loading ? "Submitting..." : "Submit"}
                                    </button>
                                )}
                            </div>
                            {/* “Already have an account? Log in” */}
                            <div className="flex justify-center mb-6">
                                <span className="text-gray-600 text-sm">
                                    If you already have an account,{" "}
                                    <Link to="/login" className="text-indigo-600 hover:underline">
                                        Log in
                                    </Link>
                                </span>
                            </div>
                        </form>
                    )}
                </div>

                {/* Right Side - Illustration */}
                <div className="md:w-1/2 w-full relative overflow-hidden h-full hidden lg:block">
                    <img
                        src="/reg_2.jpg"
                        alt="Startup Illustration"
                        className="w-full h-full object-cover"
                    />

                    <Link
                        to="/"
                        className="absolute top-4 right-4 flex items-center gap-2 text-black font-bold"
                    >
                        <FaBackward /> Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
}